import * as React from "react";
import { AdditionalContext } from "views/logic/ActionContext";
import { DEFAULT_HIGHLIGHT_COLOR } from "views/Constants";
import PossiblyHighlight from "../highlighting/PossiblyHighlight";
const SearchQueryHighlights = ({ field, value }) => /* @__PURE__ */ React.createElement(AdditionalContext.Consumer, null, ({ message }) => /* @__PURE__ */ React.createElement(
  PossiblyHighlight,
  {
    field,
    color: DEFAULT_HIGHLIGHT_COLOR,
    value,
    highlightRanges: message == null ? void 0 : message.highlight_ranges
  }
));
export default SearchQueryHighlights;
